import { useMemo } from 'react'
import { useLocalSessionId } from '@daily-co/daily-react'
import { useMediaTrackState } from './useMediaTrackState'

export function useLocalMediaTrackState() {
  const localSessionId = useLocalSessionId()
  const { isVideoTrackOn, isAudioTrackOn } = useMediaTrackState(localSessionId)

  return useMemo(() => ({ isVideoTrackOn, isAudioTrackOn }), [isVideoTrackOn, isAudioTrackOn])
}
